/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_NDC_PAYMENT,
  payload: data,
});

//Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_NDC_PAYMENT,
  isLoading: value,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

export const getNDCPaymentMaxQuarter = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.INVOICE_REGISTER_MAX_QUARTER}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_NDC_PAYMENTS_MAX_QUARTER,
        ndcPaymentMaxQuarter: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

//To get the defaut selection on the req screen when reopening the req screen
export const refreshNDCPayment = () => ({
  type: ActionTypes.REFRESH_NDC_PAYMENT,
  payload: {},
});
export const refreshNDCPaymentDisplay = () => ({
  type: ActionTypes.REFRESH_NDC_PAYMENT_DISPLAY,
  payload: {},
});
export const setNdcPaymentData = (data) => ({
  type: ActionTypes.GET_NDC_PAYMENT_RESULT_GRID,
  searchResult: data,
});

//API call for the result grid of the Institutional Claims unit tyoe
export const getNDCPaymentResultGrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_NDC_PAYMENT}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data?.ndcPaymentReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(setNdcPaymentData(response.data?.ndcPaymentReportVO));
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setNdcPaymentData([]));
      // return response;
    });
};
